if (!customElements.get("tabbed-content")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.tabList = this.querySelector('[role="tablist"]'), this.activeTab = this
        .tabList.querySelector('[aria-selected="true"]'), this.isVerticalTablist = "vertical" ===
        this.tabList.getAttribute("aria-orientation"), this.tabs = this.querySelectorAll(
          '[role="tab"]'), this.panels = this.querySelectorAll('[role="tabpanel"]'), this
        .activeTab || (this.activeTab = this.tabs[0], this.activateTab(this.activeTab)), this
        .addListeners()
    }
    addListeners() {
      this.tabList.addEventListener("click", this.handleClick.bind(this)), this.tabList
        .addEventListener("keydown", this.handleKeydown.bind(this))
    }
    handleClick(t) {
      t.target.matches('[role="tab"]') && t.target !== this.activeTab && this.activateTab(t
        .target)
    }
    handleKeydown(t) {
      switch (t.key) {
        case "ArrowLeft":
        case "ArrowRight":
          t.preventDefault(), this.isVerticalTablist || this.switchTabOnKeyPress(t.key);
          break;
        case "ArrowUp":
        case "ArrowDown":
          t.preventDefault(), this.isVerticalTablist && this.switchTabOnKeyPress(t.key);
          break;
        case "Home":
          t.preventDefault(), this.activateTab(this.tabs[0]);
          break;
        case "End":
          t.preventDefault(), this.activateTab(this.tabs[this.tabs.length - 1])
      }
    }
    switchTabOnKeyPress(t) {
      "ArrowRight" === t || "ArrowDown" === t ? this.activeTab === this.tabs[this.tabs.length -
        1] ? this.activateTab(this.tabs[0]) : this.activateTab(this.activeTab
        .nextElementSibling) : ("ArrowLeft" === t || "ArrowUp" === t) && (this.activeTab === this
          .tabs[0] ? this.activateTab(this.tabs[this.tabs.length - 1]) : this.activateTab(this
            .activeTab.previousElementSibling))
    }
    activateTab(e) {
      this.deactivateActiveTab(), t.setTabState(e, !0), e.removeAttribute("tabindex"), this
        .activeTab = e, document.activeElement.matches(".tablist__tab") && e.focus()
    }
    deactivateActiveTab() {
      t.setTabState(this.activeTab, !1), this.activeTab.setAttribute("tabindex", "-1"), this
        .activeTab = null
    }
    static setTabState(t, e) {
      t.setAttribute("aria-selected", e);
      let a = t.getAttribute("aria-controls");
      document.getElementById(a).hidden = !e
    }
  }
  customElements.define("tabbed-content", t)
}
